var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99997 8H7.99997V4H3.99997V8ZM9.99997 20H14V16H9.99997V20ZM7.99997 20H3.99997V16H7.99997V20ZM3.99997 14H7.99997V10H3.99997V14ZM14 14H9.99997V10H14V14ZM16 4V8H20V4H16ZM14 8H9.99997V4H14V8ZM16 14H20V10H16V14ZM20 20H16V16H20V20Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMobileIcon);
export default __webpack_public_path__ + "static/media/menu-mobile-icon.d5a9152f80d017b95efd4f18fa91439d.svg";
export { ForwardRef as ReactComponent };